import { useEffect, useState } from "react";

// @Utility
import { getStorage } from "@utility/app/storage";

// Redux & Action
import { useSelector } from 'react-redux';

// Component
import ImageShow from "views/components/ImageShow";
import WrapperContainer from "views/components/WrapperContainer";
import Contact from "views/components/Contact";
import Maintainer from "./Maintainer";
import NoData from "./NoData";
// import Offline from "./Offline";

// Style & CSS
import "assets/css/Error.css";
import "assets/css/Contact.css";

const Error = ({ typeError }) => {
    const reduxDataSetting = useSelector(state => state.reduxAppDataSetting.result);
    const [dataSetting, setDataSetting] = useState(null);

    const renderContact = () => {
        let dataRaw = getStorage("agent_contact");

        if (dataRaw) {
            let agent_contact = JSON.parse(dataRaw);

            return (
                <>
                    <div className="contactErrorTitleSub">
                        ช่องทางติดต่อ
                    </div>

                    <div>
                        <Contact agent_contact={agent_contact} typeAction="error" />
                    </div>
                </>
            );
        }

        return null;
    }

    const renderLogo = () => {
        if (dataSetting === null) {
            let dataRaw = getStorage("agent_logo");

            if (dataRaw !== undefined && dataRaw !== null) {
                let agent_logo = dataRaw;

                return (
                    <ImageShow className="imgLogoError" src={agent_logo} alt="Logo สล็อตออนไลน์" />
                );
            }
        }
        else {
            return (
                <ImageShow className="imgLogoError" src={dataSetting.agent.agent_image} alt="Logo สล็อตออนไลน์" />
            );
        }
    };

    useEffect(() => {
        if (reduxDataSetting !== null && reduxDataSetting !== undefined) {
            setDataSetting(reduxDataSetting);
        }

        if (reduxDataSetting === null || reduxDataSetting === undefined) {
            const storageSetting = getStorage("setting");

            if (storageSetting !== null && storageSetting !== undefined && storageSetting !== "" && storageSetting !== " ") {
                const objSetting = JSON.parse(storageSetting);
                setDataSetting(objSetting);
            }
        }
    }, [reduxDataSetting]);

    return (
        <>
            <WrapperContainer className="contentWidth" maxWidth="md">
                <div className="pagePaddingError">
                    {
                        dataSetting !== null && (
                            <div className="center">
                                {
                                    renderLogo()
                                }
                                <br /><br />
                            </div>
                        )
                    }

                    {
                        typeError === "maintainer" ?
                            <Maintainer />
                            :
                            <NoData />

                    }

                    <div className="contentBoxMarginTop">
                        {
                            renderContact()
                        }
                    </div>
                </div>
            </WrapperContainer>
        </>
    );
};

export default Error;